import {StateId} from '@wallaby-ui/core';
import {createSelector} from 'reselect';

import {ListResult} from './list_slice';
import {RootState} from 'src/js/store';

interface SelectorProps {
  listStateId: StateId;
}

const getListResult = (
  state: RootState,
  props: Pick<SelectorProps, 'listStateId'>
): ListResult => state[props.listStateId].listResult;

const STATIC_EMPTY_ARRAY = [];

export const getListSort = createSelector([getListResult], (listResult) =>
  listResult?.gridParams ? listResult.gridParams.sort : undefined
);

export const getListPagination = createSelector([getListResult], (listResult) =>
  listResult?.gridParams ? listResult.gridParams.pagination : undefined
);

export const getListFilters = createSelector([getListResult], (listResult) =>
  listResult?.gridParams ? listResult.gridParams.filters : undefined
);

export const getListScroll = createSelector([getListResult], (listResult) =>
  listResult?.gridParams ? listResult.gridParams.scroll : undefined
);

export const getListPerformedActions = createSelector(
  [getListResult],
  (listResult) =>
    listResult?.performedActions
      ? listResult.performedActions
      : STATIC_EMPTY_ARRAY
);

export const isListPerformingAction = createSelector(
  [getListPerformedActions],
  (listPerformedActions) => listPerformedActions.length > 0
);
